import { getAtlassianContextUrl } from '@atlassian/teams-common/context-config';

import { logException } from '../sentry';

export const isAbsoluteLink = (url: string): boolean => {
	return url.startsWith('http') || url.startsWith('www');
};

/**
 * For a given arbitrary path, we will prefix it with a context path of People page.
 * For example: Em-Dir in Confluence
 * - A given path is `hello-world/123`
 * - Output will be `/wiki/people/hello-world/123`
 */
export const prefixWithContextEntryPoint = (
	path: string,
	contextEntryPoint: string | null = null,
): string => {
	if (
		isAbsoluteLink(path) || // do not prefix for absolute URL
		(contextEntryPoint && path.startsWith(contextEntryPoint)) || // do not prefix if the link already has product context path
		path.startsWith('/')
	) {
		return path;
	}

	return `${contextEntryPoint}/${path}`;
};

/**
 * Takes a fully qualified URL `url` and returns a relative URL
 * by removing protocol and host.
 * Returns input `url` if it is not a fully qualified URL.
 */
export const getRelativeUrl = (url: string): string => {
	if (!isAbsoluteLink(url)) {
		return url;
	}

	try {
		const { pathname, search, hash } = new URL(url);
		return `${pathname}${search}${hash}`;
	} catch (error) {
		logException(error, 'Cannot parse URL in getRelativeUrl', { url });
	}

	return url;
};

export const EXTERNAL_LINKS = {
	TEAM_INVITE_LEARN_MORE: `${getAtlassianContextUrl(
		'support',
	)}/atlassian-account/docs/start-an-atlassian-team/#Add-or-remove-members-of-a-team`,
};
